// PromptCard.jsx
import React from 'react';
import './prompt-card.css';

const PromptCard = ({ icon, title, description, prompt, onSelect }) => {
    return (
        <div className="prompt-card" onClick={() => onSelect(prompt)}>
            <div className="prompt-card-icon">{icon}</div>
            <div className="prompt-card-title">{title}</div>
            <div className="prompt-card-description">{description}</div>
        </div>
    );
};

export default PromptCard;